import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarSecondaryComponent } from '../../components/navbar-secondary/navbar-secondary.component';
import { FooterSecondaryComponent } from '../../components/footer-secondary/footer-secondary.component';

@Component({
  selector: 'app-main',
  imports: [RouterOutlet, NavbarSecondaryComponent, FooterSecondaryComponent],
  template: `
    <app-navbar-secondary />

    <main>
      <router-outlet />
    </main>

    <app-footer-secondary />
  `,
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      padding-top: 64px;
    }
  `
})
export class MainComponent {}
